/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PrincipalType {
  GROUP = "GROUP",
  USER = "USER",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

export enum SpacePermissionType {
  ADMINISTER_SPACE = "ADMINISTER_SPACE",
  ARCHIVE_PAGE = "ARCHIVE_PAGE",
  COMMENT = "COMMENT",
  CREATE_ATTACHMENT = "CREATE_ATTACHMENT",
  CREATE_EDIT_PAGE = "CREATE_EDIT_PAGE",
  EDIT_BLOG = "EDIT_BLOG",
  EXPORT_PAGE = "EXPORT_PAGE",
  EXPORT_SPACE = "EXPORT_SPACE",
  REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT",
  REMOVE_BLOG = "REMOVE_BLOG",
  REMOVE_COMMENT = "REMOVE_COMMENT",
  REMOVE_MAIL = "REMOVE_MAIL",
  REMOVE_OWN_CONTENT = "REMOVE_OWN_CONTENT",
  REMOVE_PAGE = "REMOVE_PAGE",
  SET_PAGE_PERMISSIONS = "SET_PAGE_PERMISSIONS",
  VIEW_SPACE = "VIEW_SPACE",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SpaceAccessDetailsQuery
// ====================================================

export interface SpaceAccessDetailsQuery_space_icon {
  path: string;
  isDefault: boolean | null;
}

export interface SpaceAccessDetailsQuery_space {
  id: string | null;
  key: string | null;
  name: string | null;
  icon: SpaceAccessDetailsQuery_space_icon | null;
  type: string | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_user_profilePicture {
  width: number | null;
  height: number | null;
  isDefault: boolean | null;
  path: string;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_user {
  accountId: string | null;
  displayName: string | null;
  email: string | null;
  permissionType: SitePermissionType | null;
  profilePicture: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_user_profilePicture | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_group {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey {
  id: string | null;
  displayName: string | null;
  principalType: PrincipalType;
  user: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_user | null;
  group: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey_group | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes {
  permissions: (SpacePermissionType | null)[] | null;
  subjectKey: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes_subjectKey | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions {
  groupCount: number;
  userCount: number;
  nodes: (SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_nodes | null)[] | null;
  pageInfo: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions_pageInfo | null;
}

export interface SpaceAccessDetailsQuery_spacePermissions {
  subjectsWithPermissions: SpaceAccessDetailsQuery_spacePermissions_subjectsWithPermissions;
}

export interface SpaceAccessDetailsQuery {
  space: SpaceAccessDetailsQuery_space | null;
  spacePermissions: SpaceAccessDetailsQuery_spacePermissions;
}

export interface SpaceAccessDetailsQueryVariables {
  spaceKey: string;
  first?: number | null;
  after?: string | null;
  filterText?: string | null;
}
